import React, { useEffect, useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "../style/ExpenseTracker.css";
import { faMoneyBills } from "@fortawesome/free-solid-svg-icons/faMoneyBills";
import axios from "axios";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation } from "react-router-dom";
import ExpenseTrackerModal from "./Components/StatusSubModal";
import StatusTypeModel from "./Components/StatusSubModal";

const convert = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};

const FormatDate = (inp) => {
  let dateformat = inp.split("T")[0];
  const date = moment(dateformat, "YYYY-MM-DD");
  return date.format("DD-MMM-YYYY");
};

export default function ExpenseTracker() {
  const location = useLocation();
  const passedState = location.state;

  const [modalIsOpen, setModalIsOpen] = useState(false);
 

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  const [ExpenseList, SetExpenseList] = useState([]);
  const [PaymentMode, SetPaymentMode] = useState([]);
  const [ExpenseCategory, SetExpenseCategory] = useState([]);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [subModalIsOpen, setSubModalIsOpen] = useState(false);
  const [statusType, setStatusType] = useState(null);
  const [statusTypeSub, setStatusTypeSub] = useState({
    Status: null,
    Status_Ref: null,
  });

  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  const [isDateInput, setIsDateInput] = useState(false);

  const filteredExpense = searchQuery
    ? ExpenseList.filter((item) =>
        item.Category.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : ExpenseList;

  const InitState = {
    expenseDate: null,
    recepitNumber: null,
    expenseCategory: null,
    expenseAmount: null,
    modeofPayment: null,
    expenseReason: null,
    user: username,
  };

  const [formData, setFormData] = useState(InitState);

  const handleSubModalOpen = () => setSubModalIsOpen(true);
  const handleSubModalClose = () => setSubModalIsOpen(false);

  const handleStatusOnChange = async (e) => {
    let { name, value } = e.target;
    setStatusTypeSub({ ...statusTypeSub, [name]: value.toUpperCase() });
  };

  function selectStatusType(statusType) {
    switch (statusType) {
      case "ExpenseCategory":
        return "Expense_Category";
        break;

      case "ModeOfPayment":
        return "Mode_of_Payment";
        break;

      default:
        break;
    }
  }

  const handleStatusTypeSubjectSubmit = async (event) => {
    event.preventDefault();
    const status = statusType ? selectStatusType(statusType) : "";
    console.log(status, statusType);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/AddStatusTypeSub/${status}`,
          statusTypeSub,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
            setStatusTypeSub({ Status: null, Status_Ref: null });
            if (statusType === "ExpenseCategory") FetchExpenseCategory();
            if (statusType === "ModeOfPayment") fetchModeOfPayment();
            setStatusType(null);
            handleSubModalClose();
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const fetchModeOfPayment = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Mode_Of_Payment`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetPaymentMode(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const FetchExpenseCategory = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Expense_Category`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetExpenseCategory(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const fetchExpenseList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/expense/FetchExpenseList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetExpenseList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchExpenseList();
    FetchExpenseCategory();
    fetchModeOfPayment();
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  }, []);

  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: false, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const handleEdit = (Expense) => {
    const InitStateEdit = {
      expenseId: Expense.Expense_Id,
      expenseDate:
        Expense.Date == null ? null : convert(Expense.Date.toString()),
      recepitNumber: Expense.Recepit_Number,
      expenseCategory: Expense.Category,
      expenseAmount: Expense.Amount,
      modeofPayment: Expense.Mode_of_Payment,
      expenseReason: Expense.Reason,
      user: passedState.username,
    };
    setSelectedExpense(InitStateEdit);
    //console.log(InitStateEdit)
    setModalIsOpen(true);
  };

  const handleModalClose = () => {
    const confirmClose = window.confirm("Are you sure you want to close?");
    if (confirmClose) {
      setModalIsOpen(false);
      setFormData(InitState);
      setSelectedExpense(null);
    }
  };

  const handleFocus = () => {
    setIsDateInput(true);
  };
  const handleFocus1 = () => {
    setIsDateInput(false);
  };

  const handleChange = (e) => {
    //console.log(formData)
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    if (name === "expenseReason") {
      let result = pattern.test(value);
      if (result) {
        setFormData({
          ...formData,
          [name]: value.replace(pattern, ""),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (name === "expenseAmount" || name === "recepitNumber") {
      setFormData({
        ...formData,
        [name]: value.replace(/[^0-9]/g, ""),
      });
    } else if (name === "expenseDate") {
      let date = new Date(e.target.value);
      //console.log((convert(date)))
      if (!isNaN(date)) {
        setFormData({
          ...formData,
          [name]: convert(date),
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    if (name === "expenseReason") {
      let result = pattern.test(value);
      if (result) {
        setSelectedExpense({
          ...selectedExpense,
          [name]: value.replace(pattern, ""),
        });
      } else {
        setSelectedExpense({
          ...selectedExpense,
          [name]: value,
        });
      }
    } else if (name === "expenseAmount" || name === "recepitNumber") {
      setSelectedExpense({
        ...selectedExpense,
        [name]: value.replace(/[^0-9]/g, ""),
      });
    } else if (name === "expenseDate") {
      let date = new Date(e.target.value);
      //console.log((convert(date)))
      if (!isNaN(date)) {
        setSelectedExpense({
          ...selectedExpense,
          [name]: convert(date),
        });
      }
    } else {
      setSelectedExpense({
        ...selectedExpense,
        [name]: value,
      });
    }
  };

  const UpdateForm = async (e) => {
    e.preventDefault()
    try {
      await axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/expense/UpdateExpense/${selectedExpense.expenseId}`,
          selectedExpense,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          setSelectedExpense([]);
          fetchExpenseList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    finally{
      setSelectedExpense([]);
      closeModal();
    }
    
  };


  const handleDelete = async (Expense) => {
    try {
      const confirm= window.confirm("Are you sure you want to delete this?")
      if(!confirm) return
      await axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/expense/DeleteExpense/${Expense.Expense_Id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          fetchExpenseList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    //console.log(formData)
    if (formData.expenseDate === null) {
      WarningMSG("Fill Date Field");
    } else {
      //console.log(formData)

      try {
        await axios
          .post(
            `${process.env.REACT_APP_API_BASE_URL}/expense/AddExpense`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem(
                  "access_token"
                )}`,
              },
            }
          )
          .then((res) => {
            SuccessMSG(res.data.message);
            fetchExpenseList();
          })
          .catch((error) => {
            if (error.response && error.response.status !== 200)
              FailedMSG("Something went Wrong");
          });
      } catch (error) {
        if (error.response && error.response.status !== 200)
          FailedMSG("Something went Wrong");
      }
      //console.log(formData);
      setFormData(InitState);
      closeModal();
    }
  };

  return (
    <>
      <ToastContainer />
      <Appbar
        username={passedState.username}
        rights={passedState.rights}
      ></Appbar>
      <div className="ExpenseTracker">
        <Menu
          username={passedState.username}
          rights={passedState.rights}
        ></Menu>
        <div className="ExpenseTrackerPage">
          <p className="ExpenseTrackerHeadLabel">Expense Tracker</p>
          <div className="ExpenseTrackerHeaders">
            <div className="ExpenseTrackerRegSearch">
              <input
                className="ExpenseTrackerRegInput"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Category"
              ></input>
              <button className="ExpenseTrackerSearchBtn">
                <FontAwesomeIcon
                  className="ExpenseTrackerRegSearchIcon"
                  title="Search"
                  icon={faSearch}
                ></FontAwesomeIcon>
              </button>
            </div>
            <button
              className="NewExpenseTrackerBtn"
              title="Add New"
              onClick={openModal}
            >
              Add New{" "}
              <FontAwesomeIcon
                className="ExpenseTrackerAddNewIcon"
                icon={faPlus}
              ></FontAwesomeIcon>
            </button>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleModalClose}
            shouldCloseOnOverlayClick={false}
            contentLabel="Expense Tracker Form"
            center
            style={{
              overlay: {
                background: "rgba(0,0,0,0.6)",
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              },
              content: {
                background: "linear-gradient(168deg, #c1e0ff 0%, #efdeff 100%)",
                position: "absolute",
                top: "40px",
                left: "25%",
                right: "25%",
                bottom: "40px",
                height: "70%",
                width: "50%",
                overflow: "scroll",
              },
            }}
          >
            <FontAwesomeIcon
              className="ExpenseTrackerFormCloseBtn"
              onClick={handleModalClose}
              title="Close"
              icon={faClose}
            ></FontAwesomeIcon>
            <p className="ExpenseTrackerFormHeadLabel">
              {selectedExpense?.expenseId ? "Edit Expense" : "Add Expense"}
            </p>
            <form
              className="ExpenseTrackerForm"
              onSubmit={selectedExpense?.expenseId ? UpdateForm : handleSubmit}
            >
              <div className="ExpenseTrackerFormFlex">
                <div className="ExpenseTrackerform1">
                  <div className="ExpenseTrackerformFeilds">
                    <label className="ExpenseTrackerFormLabels">
                      Date <span>*</span>{" "}
                    </label>
                    <input
                      placeholder="01-Jan-1900"
                      className="ExpenseTrackerFormInputs"
                      required
                      type={isDateInput ? "date" : "text"}
                      onFocus={handleFocus}
                      onBlur={handleFocus1}
                      readOnly={!isDateInput}
                      value={
                        selectedExpense
                          ? selectedExpense.expenseDate
                            ? FormatDate(selectedExpense.expenseDate)
                            : selectedExpense.expenseDate
                          : formData.expenseDate
                          ? FormatDate(formData.expenseDate)
                          : formData.expenseDate
                      }
                      onChange={
                        selectedExpense?.expenseId ? handleUpdate : handleChange
                      }
                      name="expenseDate"
                    ></input>
                  </div>
                </div>
                <div className="ExpenseTrackerform1">
                  <div className="ExpenseTrackerformFeilds">
                    <label className="ExpenseTrackerFormLabels">
                      Receipt Number{" "}
                    </label>
                    <input
                      placeholder="Receipt Number"
                      value={
                        selectedExpense?.recepitNumber || formData.recepitNumber
                      }
                      onChange={selectedExpense ? handleUpdate : handleChange}
                      className="ExpenseTrackerFormInputs"
                      type="text"
                      name="recepitNumber"
                      maxLength={16}
                      pattern="\d{6,10}"
                    ></input>
                  </div>
                  <div className="ExpenseTrackerformFeilds">
                    <label className="ExpenseTrackerFormLabels">
                      Category <span>* </span>{" "}
                      <Link
                        style={{ fontSize: "12px" }}
                        state={{
                          username: passedState.username,
                          rights: passedState.rights,
                        }}
                        to={""}
                        onClick={() => {
                          setStatusType("ExpenseCategory");
                          handleSubModalOpen();
                        }}
                      >
                        {" "}
                        Add New Category
                      </Link>{" "}
                    </label>
                    <select
                      className="ExpenseTrackerFormInputs2"
                      required
                      value={
                        selectedExpense
                          ? selectedExpense.expenseCategory
                          : formData.expenseCategory
                      }
                      onChange={
                        selectedExpense?.expenseId ? handleUpdate : handleChange
                      }
                      name="expenseCategory"
                    >
                      <option value={""}> Select </option>
                      {ExpenseCategory.map((item, index) => (
                        <option key={index} value={item.Status_Ref}>
                          {item.Status_Ref}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="ExpenseTrackerform1">
                  <div className="ExpenseTrackerformFeilds">
                    <label className="ExpenseTrackerFormLabels">
                      Amount (₹) <span>*</span>
                    </label>
                    <input
                      placeholder="₹ Amount"
                      className="ExpenseTrackerFormInputs"
                      required
                      value={
                        selectedExpense?.expenseAmount || formData.expenseAmount
                      }
                      onChange={
                        selectedExpense?.expenseId ? handleUpdate : handleChange
                      }
                      type="text"
                      name="expenseAmount"
                    ></input>
                  </div>
                  <div className="ExpenseTrackerformFeilds">
                    <label className="ExpenseTrackerFormLabels">
                      Mode of Payment <span>*</span>{" "}
                      <Link
                        style={{ fontSize: "12px" }}
                        state={{
                          username: passedState.username,
                          rights: passedState.rights,
                        }}
                        onClick={() => {
                          setStatusType("ModeOfPayment");
                          handleSubModalOpen();
                        }}
                        to={""}
                      >
                        {" "}
                        (Add Payment Mode)
                      </Link>{" "}
                    </label>
                    <select
                      className="ExpenseTrackerFormInputs2"
                      required
                      value={
                        selectedExpense?.modeofPayment || formData.modeofPayment
                      }
                      onChange={
                        selectedExpense?.expenseId ? handleUpdate : handleChange
                      }
                      name="modeofPayment"
                    >
                      <option value={""}> Select </option>
                      {PaymentMode.map((item, index) => (
                        <option key={index} value={item.Status_Ref}>
                          {item.Status_Ref}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="ExpenseTrackerform1">
                  <div className="ExpenseTrackerformFeilds1">
                    <label className="ExpenseTrackerFormLabels">
                      Reason <span>*</span>
                    </label>
                    <textarea
                      placeholder="Reason"
                      required
                      value={
                        selectedExpense?.expenseReason || formData.expenseReason
                      }
                      onChange={
                        selectedExpense?.expenseId ? handleUpdate : handleChange
                      }
                      className="ExpenseTrackerFormInputs1"
                      type="text"
                      name="expenseReason"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="ExpenseTrackerFormFooter">
                <div className="ExpenseTrackerFormFooterBtns">
                  <button
                    className="ExpenseTrackerFormSubmitBtn"
                    title="Confirm"
                    type="submit"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </form>
          </Modal>
          {/* Submodal */}

          <StatusTypeModel
            isOpen={subModalIsOpen}
            onClose={handleSubModalClose}
            statusTypeSub={statusTypeSub}
            handleChange={handleStatusOnChange}
            handleSubmit={handleStatusTypeSubjectSubmit}
          />

          <div className="ExpenseTrackerLists">
            {Number(filteredExpense.length) === 0 ? (
              <p
                className="mx-auto"
                style={{ textAlign: "center", width: "100%" }}
              >
                There is No Expense Record Found
              </p>
            ) : (
              filteredExpense.map((items, index) => {
                return (
                  <div key={index} className="ExpenseTrackerIndex">
                    <div className="ExpenseTrackerGrp0">
                      <div className="ExpenseTrackerIconGrp">
                        <FontAwesomeIcon
                          className="ExpenseTrackerUsesCircle"
                          icon={faMoneyBills}
                        ></FontAwesomeIcon>
                      </div>
                      <div
                        className="ExpenseTrackerGrp"
                        style={{ width: "80%" }}
                      >
                        <p className="ExpenseTrackerGrpLables">Category</p>
                        <p className="ExpenseTrackerGrpValues">
                          {items.Category}
                        </p>
                      </div>
                    </div>
                    <div className="ExpenseTrackerGrp">
                      <p className="ExpenseTrackerGrpLables">Amount</p>
                      <p className="ExpenseTrackerGrpValues">
                        ₹ {items.Amount}
                      </p>
                    </div>
                    <div className="ExpenseTrackerGrp">
                      <p className="ExpenseTrackerGrpLables">Date</p>
                      <p className="ExpenseTrackerGrpValues">
                        {FormatDate(convert(items.Date))}
                      </p>
                    </div>
                    <div className="ExpenseTrackerGrpBtn">
                      <FontAwesomeIcon
                        className="ExpenseTrackerEditIcon"
                        title="Edit"
                        onClick={() => handleEdit(items)}
                        icon={faEdit}
                      ></FontAwesomeIcon>
                      <FontAwesomeIcon
                        className="ExpenseTrackerDeleteIcon"
                        title="Delete"
                        onClick={() => handleDelete(items)}
                        icon={faTrash}
                      ></FontAwesomeIcon>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}
